import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useMixer } from '../context/MixerContext';
import { transformProject } from '../utils/contentTransform';
import './ProjectCard.css';

// Projects that have deep-dive content
const hasDeepDive = ['wufers', '519-inventory'];

export default function ProjectCard({ project, index, onDeepDive }) {
  const { mixerState } = useMixer();
  const transformed = transformProject(project, mixerState);
  
  const showTechEmphasis = transformed.emphasis.technical > 0.6;
  const canDeepDive = hasDeepDive.includes(project.id);
  
  return (
    <motion.article 
      className={`project-card ${canDeepDive ? 'project-card--has-deep-dive' : ''}`}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: index * 0.1 }}
      layout
      onClick={canDeepDive ? () => onDeepDive(project.id) : undefined}
    >
      <div className="project-card__header">
        <h4 className="project-card__title">{project.title}</h4>
        {project.client && (
          <span className="project-card__client">{project.client}</span>
        )}
        {project.event && (
          <span className="project-card__event">{project.event}</span>
        )}
        <span className="project-card__period">{project.period}</span>
      </div>
      
      <AnimatePresence mode="wait">
        <motion.p 
          key={transformed.displayDescription}
          className="project-card__description"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.25 }}
        >
          {transformed.displayDescription}
        </motion.p>
      </AnimatePresence>
      
      <div className="project-card__footer">
        <div className="project-card__technologies">
          {project.technologies.map(tech => (
            <span 
              key={tech} 
              className="project-card__tech"
              style={{ opacity: showTechEmphasis ? 1 : 0.6 }}
            >
              {tech}
            </span>
          ))}
        </div>
        
        {canDeepDive && (
          <span className="project-card__deep-dive-hint">
            View Case Study →
          </span>
        )}
      </div>
      
      <div 
        className="project-card__type-badge"
        data-type={project.type}
      >
        {project.type}
      </div>
    </motion.article>
  );
}
